module.exports = __webpack_public_path__ + "img/KSC08770.163edf15.jpg";